<div class="secure-site">
  <figure><span class="ms-icon icon-shield"></span></figure>
  <p>El proceso de pago en nuestra web es seguro. Tus datos personales y bancarios están protegidos.</p>
</div>
